import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['addItem', 'template']

  addAssociation (event) {
    event.preventDefault();
    const randomNumber = Math.floor(Math.random() * (10 ** 10));
    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, randomNumber);
    this.addItemTarget.insertAdjacentHTML('beforeend', content);
  }

  // eslint-disable-next-line class-methods-use-this
  removeAssociation (event) {
    event.preventDefault();
    const item = event.target.closest('.nested-fields');
    item.remove();
  }
}
